module.exports = __webpack_public_path__ + "static/img/challenge-2.281b798.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/characters/challenge-2.svg
// module id = Hwa7
// module chunks = 1